import gql from 'graphql-tag';

const getContractProductsQuery = gql`
  query GetContractProducts(
    $organisationId: String!
    $roleId: String!
  ) {
    getContractProducts(
      organisationId: $organisationId, 
      roleId: $roleId
    ) {
      product
      status
      daysToExpiry
      closable
    }
  }
`;

const queryGetContractProducts = () => ({
  query: getContractProductsQuery,
  module: 'organisations',
  buildVariables: ({
    organisationId,
    roleId



  }) => ({
    organisationId,
    roleId
  })
});

export default queryGetContractProducts;